import React from 'react';

const SelectMemberStamp = () => (
  <div className="select-members-only">
    <i className="far fa-lock-alt" />
    Annual Members Only
  </div>
);

export default SelectMemberStamp;
